'use strict';

wbApp.directive('wbClassroomCombo', ['$timeout', '$translate', 'classroomSvc',
    function ($timeout, $translate, classroomSvc) {
        function formatResult(model) {
            if (!model) { return; }

            if (model.isDeleted) {
                if (model.description) {
                    return "<div class='row'>" +
                               "<div class='col-md-5'>" + model.name + ' (' + $translate.instant('TXT_VAL_DELETED') + ')' + "</div>" +
                               "<div class='col-md-7'>" + (model.description || '') + "</div>" +
                           "</div>";
                } else {
                    return "<div class='row'>" +
                               "<div class='col-md-12'>" + model.name + ' (' + $translate.instant('TXT_VAL_DELETED') + ')' + "</div>" +
                           "</div>";
                }
            } else {
                if (!model.active) {
                    if (model.description) {
                        return "<div class='row'>" +
                                   "<div class='col-md-5'>" + model.name + ' (' + $translate.instant('TXT_VAL_NOT_ACTIVE') + ')' + "</div>" +
                                   "<div class='col-md-7'>" + (model.description || '') + "</div>" +
                               "</div>";
                    } else {
                        return "<div class='row'>" +
                                   "<div class='col-md-12'>" + model.name + ' (' + $translate.instant('TXT_VAL_NOT_ACTIVE') + ')' + "</div>" +
                               "</div>";
                    }
                } else {
                    if (model.description) {
                        return "<div class='row'>" +
                                   "<div class='col-md-5'>" + model.name + "</div>" +
                                   "<div class='col-md-7'>" + (model.description || '') + "</div>" +
                               "</div>";
                    } else {
                        return "<div class='row'>" +
                                   "<div class='col-md-12'>" + model.name + "</div>" +
                               "</div>";
                    }
                }
            }
        }

        function formatSelection(model) {
            if (model.isDeleted) {
                return model.name + ' (' + $translate.instant('TXT_VAL_DELETED') + ')'
            } else {
                if (!model.active) {
                    return model.name + ' (' + $translate.instant('TXT_VAL_NOT_ACTIVE') + ')'
                } else {
                    return model.name;
                }
            }
        }

        return {
            restrict: 'A',
            require: 'ngModel',
            priority: 1,
            replace: true,
            scope: {
                filterForReservations: '=',
                filterForCourses: '=',
                allowClear: '='
            },
            link: function (scope, elm, attrs, ctrl) {
                var models = classroomSvc.getAllActiveAsync( /* classroomIDtoInclude */ ctrl.$modelValue, /* filterForReservations */ !!scope.filterForReservations, /* filterForCourses */ !!scope.filterForCourses);
                $timeout(function () {

                    $(elm).select2({
                        placeholder: (typeof scope.placeholder !== 'undefined') 
                            ? attrs.placeholder
                            : $translate.instant('TXT_PLACEHOLDER_SELECT_CLASSROOM'),
                        formatResult: formatResult,
                        formatSelection: formatSelection,
                        dropdownAutoWidth: true,
                        allowClear: (typeof scope.allowClear !== 'undefined') ? scope.allowClear : true,
                        minimumResultsForSearch: -1,
                        data: models
                    });

                    ctrl.$render();
                });

                ctrl.$parsers.unshift(function (viewValue) {
                    if (!viewValue) {
                        return 0;
                    } else {
                        return parseInt(viewValue);
                    }
                });

                ctrl.$formatters.unshift(function (value) {
                    if (!value) {
                        return "";
                    } else {
                        return value + "";
                    }
                });

                ctrl.$render = function () {
                    models.$promise.then(function () {
                        $(elm).select2('val', ctrl.$viewValue);
                    });
                }

                elm.bind("$destroy", function () {
                    elm.select2("destroy");
                });

                attrs.$observe('readonly', function (value) {
                    elm.select2('readonly', !!value);
                });
            }
        }
    }]);    